import { Component } from '@angular/core';
import { NavbarComponent } from "../../../partials/navbar/navbar.component";
import { FooterComponent } from "../../../partials/footer/footer.component";
import { LanguageService } from '../../../services/language.service';

@Component({
  selector: 'app-technology',
  standalone: true,
  imports: [NavbarComponent, FooterComponent],
  templateUrl: './technology.component.html',
  styleUrl: './technology.component.css'
})
export class TechnologyComponent {
  texts:any;
  constructor(private langServ:LanguageService){
    this.texts = langServ.getWebisteTexts().technology;
  }

  navigateToId(id: string): void {
    if (typeof document === 'undefined') {
      return;
    }
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    }
  }
}
